module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_7016.3de3e81d.png";